import { Injectable } from '@angular/core';
import { GeoJson } from '../models/map';
import * as mapboxgl from 'mapbox-gl';

@Injectable()
export class MapService {
  constructor() {
  }
}


// WEBPACK FOOTER //
// ./src/app/services/map.service.ts